import { useTranslation } from "react-i18next";
import { CDN_HOST } from "env/env.dev";

import "./GoFundMeBanner.scss";

const SHOW_GOFUNDME_CAMPAIGN = true;
const GOFUNDME_CAMPAIGN_URL = "https://gofund.me/5f9f57b87";
const GOFUNDME_CAMPAIGN_IMAGE_URL = `${CDN_HOST}/images/dts_colombiarebuild.jpg`;

const GoFundMeBanner = () => {
  const { t } = useTranslation(["homeTranslations"]);

  if (!SHOW_GOFUNDME_CAMPAIGN) {
    return null;
  }

  return (
    <aside className="GoFundMeBanner" aria-label={t("goFundMeCampaignLabel")}>
      <figure className="GoFundMeBanner__image">
        <img
          src={GOFUNDME_CAMPAIGN_IMAGE_URL}
          alt={t("goFundMeCampaignImageAlt")}
          loading="eager"
          decoding="async"
        />
      </figure>
      <div className="GoFundMeBanner__content">
        <span className="GoFundMeBanner__eyebrow">{t("goFundMeCampaignEyebrow")}</span>
        <h2>{t("goFundMeCampaignTitle")}</h2>
        <h3>{t("goFundMeCampaignSubtitle")}</h3>
        <p>{t("goFundMeCampaignTextOne")}</p>
        <p>{t("goFundMeCampaignTextTwo")}</p>
        <strong>{t("goFundMeCampaignPhrase")}</strong>
        <a
          className="GoFundMeBanner__button"
          href={GOFUNDME_CAMPAIGN_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("goFundMeCampaignButton")}
        </a>
      </div>
    </aside>
  );
};

export default GoFundMeBanner;
